import PropTypes from 'prop-types'
import React from 'react'
import classes from './Content.module.scss'

export class Content extends React.Component {
  static propTypes = {
    className: PropTypes.string
  }

  render () {
    let {
      children,

      className,
      onClick,

      ...restProps
    } = this.props

    let compClassName = classes.content
    if (onClick) compClassName += ' ' + classes.clickable
    if (className) compClassName += ' ' + className

    return (
      <div
        {...restProps}
        className={compClassName}
        onClick={onClick}
      >
        {children}
      </div>
    )
  }
}

export default Content
